import { FC } from "react";
import { copy } from "shared/assets";
import { IInfoBlockItem } from "shared/types";

import { useScrollToHashOnFirstRender } from "shared/utils";

import { InfoBlockItemsOverview } from "./containers";

const {
  bandAssets: { sidemenu: placesCopy },
} = copy;

export const PlacesOverviewPage: FC = () => {
  useScrollToHashOnFirstRender();

  return <InfoBlockItemsOverview type={IInfoBlockItem.place} title={placesCopy.places} />;
};
